import { useSelector } from 'react-redux';

export const motiveGroups = [
  {
    id: 'Problemas con mi pedido o entrega',
    name: 'Problemas con mi pedido o entrega',
    description:
      'Deseas cancelar porque hubo inconvenientes en la compra, despacho o retiro.',
    motives: [
      'No recibí mi compra en el tiempo estimado',
      'Me cambiaron la fecha de despacho',
      'Error en dirección de despacho/sucursal de retiro',
      'Problemas con retiro en tienda',
      'Inconvenientes con pago en cuotas',
    ],
  },
  {
    id: 'El producto no era lo que esperaba',
    name: 'El producto no era lo que esperaba',
    description:
      'Solicitaste o recibiste el producto, pero no quedaste conforme.',
    motives: [
      'El producto no cumplió con mis expectativas',
      'Problemas con la talla, color o tamaño',
    ],
  },
  {
    id: 'Cambio de opinión',
    name: 'Cambio de opinión',
    description:
      'Ya no quieres la compra por decisión personal sin relación con el producto o el servicio.',
    motives: [
      'Me equivoqué al comprar',
      'Ya no lo quiero, no lo necesito',
      'Encontré el producto más barato en otro lugar',
    ],
  },
];

export const getMotiveOptions = (group) =>
  group ? group.motives.map((motive) => ({ id: motive, name: motive })) : [];

export const MakeFields = () => {
  const { rut, orderId, cud, sku } = useSelector((state) => state.issuesSlice);

  return [
    {
      name: 'sku',
      label: 'SKU',
      disabled: true,
      required: true,
      value: sku,
      hidden: true,
    },
    {
      name: 'cud',
      label: 'Cud',
      disabled: true,
      required: false,
      value: cud,
      hidden: true,
    },
    {
      name: 'orderId',
      label: 'Oc',
      disabled: true,
      required: true,
      value: orderId,
      hidden: true,
    },
    {
      name: 'motiveClient',
      inputType: 'radio',
      disabled: true,
      required: true,
      hidden: true,
    },
    {
      name: 'rut',
      inputAdornment: '',
      label: 'RUT',
      textArea: '',
      disabled: true,
      required: true,
      helper: 'Sin puntos, pero con guión Ej: 12345678-9',
      value: rut,
    },
    {
      name: 'clientName',
      inputAdornment: '',
      label: 'Nombre completo',
      textArea: '',
      disabled: false,
      required: true,
    },
    {
      name: 'phone',
      inputAdornment: '',
      label: 'Teléfono',
      textArea: '',
      disabled: false,
      required: true,
      helper: 'Ingresar 9 dígitos',
    },
    {
      name: 'email',
      inputAdornment: '',
      label: 'Correo',
      textArea: '4',
      disabled: false,
      required: true,
    },
    {
      name: 'paymentMethod',
      inputAdornment: '',
      label: 'Medio de pago',
      disabled: false,
      required: true,
      inputType: 'select',
    },
    {
      name: 'bank',
      inputAdornment: '',
      label: 'Banco',
      disabled: false,
      required: true,
      inputType: 'select',
    },
    {
      name: 'accountNumber',
      inputAdornment: '',
      label: 'Número de cuenta',
      disabled: false,
      required: true,
    },
    {
      name: 'cancelAddress',
      inputAdornment: '',
      label: 'Dirección',
      disabled: false,
      required: true,
    },
    {
      name: 'comment',
      multiline: true,
      rows: 4,
      inputAdornment: '',
      label: 'Escribir comentario',
      disabled: false,
      required: true,
      helper: '0/250',
    },
  ];
};
